var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"col col-12"},[_vm._v(" "+_vm._s(_vm.$t('access_denied_role_message'))+" ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }